import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(getLatLonName),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doQueryPlaces),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadPlace),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadDetectedLocation),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(watchLocationInputSagas);

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { call, fork, put, select, takeEvery } from 'redux-saga/effects';
import * as logger from 'universal-logger';
import { deepExtract } from 'helpers/deep';
import { selectUserDetectedLocation } from 'redux/modules/locale';
import { glsLocation, searchLocationAutocomplete, searchLocationDetails } from 'redux/saga/entities/bound';
import { setInputLocation, setPlaceQuery } from './LocationInput.reducer';
export var LOAD_DETECTED_LOCATION = 'LOCATION_INPUT/LOAD_DETECTED_LOCATION';
export var LOAD_PLACE = 'LOCATION_INPUT/LOAD_PLACE';
export var QUERY_PLACES = 'LOCATION_INPUT/QUERY_PLACES';
export var loadDetectedLocation = function loadDetectedLocation() {
  return {
    type: LOAD_DETECTED_LOCATION
  };
};
export var loadPlace = function loadPlace(placeId) {
  return {
    type: LOAD_PLACE,
    placeId: placeId
  };
};
export var queryPlaces = function queryPlaces(query) {
  return {
    type: QUERY_PLACES,
    query: query
  };
};
export function getLatLonName(client, lat, lon) {
  var _ref, msa, areas;

  return regeneratorRuntime.wrap(function getLatLonName$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return call(fetchEntityIfNeeded, glsLocation, [client, lat, lon]);

        case 2:
          _ref = _context.sent;
          msa = _ref.msa;
          areas = _ref.areas;
          return _context.abrupt("return", deepExtract('city', msa) || deepExtract('city', areas) || deepExtract('most_specific_area', areas));

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function doQueryPlaces(client, _ref2) {
  var query, detectedLocation;
  return regeneratorRuntime.wrap(function doQueryPlaces$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          query = _ref2.query;
          _context2.prev = 1;

          if (!query) {
            _context2.next = 8;
            break;
          }

          _context2.next = 5;
          return select(selectUserDetectedLocation);

        case 5:
          detectedLocation = _context2.sent;
          _context2.next = 8;
          return call(fetchEntityIfNeeded, searchLocationAutocomplete, [client, {
            query: query,
            near: detectedLocation,
            type: 'cities'
          }], {
            key: "locationInput_".concat(query)
          });

        case 8:
          _context2.next = 10;
          return put(setPlaceQuery(query));

        case 10:
          _context2.next = 16;
          break;

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 16;
          return call(logger.warn, 'LocationInput: Failed while querying location', _context2.t0);

        case 16:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 12]]);
}
export function doLoadPlace(client, _ref3) {
  var placeId, _ref4, lat, lon, name;

  return regeneratorRuntime.wrap(function doLoadPlace$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          placeId = _ref3.placeId;

          if (placeId) {
            _context3.next = 3;
            break;
          }

          return _context3.abrupt("return");

        case 3:
          _context3.prev = 3;
          _context3.next = 6;
          return call(fetchEntityIfNeeded, searchLocationDetails, [client, placeId]);

        case 6:
          _ref4 = _context3.sent;
          lat = _ref4.lat;
          lon = _ref4.lon;
          name = _ref4.name;
          _context3.next = 12;
          return put(setInputLocation({
            lat: lat,
            lon: lon,
            name: name
          }));

        case 12:
          _context3.next = 18;
          break;

        case 14:
          _context3.prev = 14;
          _context3.t0 = _context3["catch"](3);
          _context3.next = 18;
          return call(logger.warn, 'LocationInput: Failed while retrieving place data', _context3.t0);

        case 18:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[3, 14]]);
}
export function doLoadDetectedLocation(client) {
  var detectedLocation, lat, lon, name;
  return regeneratorRuntime.wrap(function doLoadDetectedLocation$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return select(selectUserDetectedLocation);

        case 2:
          detectedLocation = _context4.sent;

          if (!(!detectedLocation || detectedLocation.lat === 0 && detectedLocation.lon === 0)) {
            _context4.next = 7;
            break;
          }

          _context4.next = 6;
          return call(logger.warn, 'LocationInput: Failed while retrieving current location data, no location', detectedLocation);

        case 6:
          return _context4.abrupt("return");

        case 7:
          _context4.prev = 7;
          lat = detectedLocation.lat, lon = detectedLocation.lon;
          _context4.next = 11;
          return call(getLatLonName, client, lat, lon);

        case 11:
          name = _context4.sent;
          _context4.next = 14;
          return put(setInputLocation({
            lat: lat,
            lon: lon,
            name: name
          }));

        case 14:
          _context4.next = 20;
          break;

        case 16:
          _context4.prev = 16;
          _context4.t0 = _context4["catch"](7);
          _context4.next = 20;
          return call(logger.warn, 'LocationInput: Failed while retrieving current location data', _context4.t0);

        case 20:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[7, 16]]);
}
export function watchLocationInputSagas(client) {
  return regeneratorRuntime.wrap(function watchLocationInputSagas$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return fork(takeEvery, QUERY_PLACES, doQueryPlaces, client);

        case 2:
          _context5.next = 4;
          return fork(takeEvery, LOAD_PLACE, doLoadPlace, client);

        case 4:
          _context5.next = 6;
          return fork(takeEvery, LOAD_DETECTED_LOCATION, doLoadDetectedLocation, client);

        case 6:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}